import { ArrowRightIcon } from '@heroicons/react/24/outline'
import { AtSymbolIcon } from '@heroicons/react/24/solid'
import React, { useCallback, useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { Fade } from 'react-reveal'
import { Link, useHistory } from 'react-router-dom'
import { api } from '../api'
import FormBtn from '../components/elements/Buttons/FormBtn'
import GoBackBtn from '../components/elements/Buttons/GoBackBtn'
import { FormCardInput } from '../components/FormCard'
import ToastAction from '../components/ToastAction'
import SaraRecovery from '../images/sara @.png'
import Pouces from '../images/sara_pouces.png'
import { classNames } from '../utils'

export default function PasswordRecovery() {
  const { register, handleSubmit, formState: { errors } } = useForm()
  const history = useHistory()
  const [option, setOption] = useState({
    loading: false,
    mailSended: false,
    email: null
  })

  const _submit = useCallback(async data => {
    try {
      setOption(s => ({ ...s, loading: true }))
      await api.auth().forgotPassword(data.email)
      sessionStorage.setItem('email_recovery', data.email)
      setOption({ loading: false, mailSended: true, email: data.email })
    } catch (error) {
      setOption({ loading: false, mailSended: false, email: null })
      if ('UserNotFoundException' == error.code) {
        toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Cet email n'existe pas !" description="Voulez-vous créer un compte ?" okAction={() => history.push('/signup')} />)
      }
      else if ('LimitExceededException' == error.code) {
        toast.custom((t) => <ToastAction saraExpression="hangry" toastRef={t} label="Revenez plus tard !" description="Vous avez dépassé la limite d'essaie avec cet email." />)
      }
      else toast.custom((t) => <ToastAction saraExpression="sorry" toastRef={t} label="Oups !!" description="Nous avons rencontré un problème. Veuillez réessayer SVP." />)
    }
  }, [])
  return (
    <div className='min-h-screen bg-gray-50 flex items-center justify-center p-4 relative'>
      <GoBackBtn />
      <Fade right>
        <section className='flex flex-col items-center w-[500px] space-y-10'>
          <div className='flex flex-col items-center space-y-2'>
            <img src={option.mailSended ? Pouces : SaraRecovery} className={classNames("h-64 transform", option.mailSended ? 'translate-x-3' : 'translate-x-8 -mb-8')} />
            <h1 className="text-gray-600 font-bold text-2xl">{option.mailSended ? 'Le mail est parti.' : 'Récupération du mot de passe'}</h1>
            <p className="text-center text-gray-500">{option.mailSended ? "Vérifier votre boite de réception. N'hésitez pas à regarder dans vos spams si vous ne le trouvez pas." : 'Renseignez le champ ci-dessous. Nous vous enverrons un mail de réinitialisation de mot de passe.'}</p>
          </div>

          {!option.mailSended && <form onSubmit={handleSubmit(_submit)} className="w-full space-y-10">
            <FormCardInput
              autoFocus
              type='email'
              placeholder='E-mail de contact'
              name='email'
              defaultValue={option.email}
              register={register}
              errorType={errors?.email?.type}
              icon={<AtSymbolIcon className="w-4 h-4 text-gray-500" />}
            />
            <div>
              <FormBtn disabled={option.loading} label={option.loading ? 'Envoie...' : 'Envoyer'} />
              <p className='text-xs text-center text-gray-500 font-medium'>Vous avez déjà un compte ? <Link to="/login" className='text-teal-700 underline font-bold'>Connectez-vous</Link></p>
            </div></form>}
          <div className='w-full space-y-1'>
            {option.mailSended && <Link to="/reset-password" className="w-full uppercase space-x-2 flex justify-center py-3 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 disabled:bg-gray-500 disabled:text-gray-300 disabled:cursor-not-allowed transition-colors">
              <span>Réinitialisation</span> <ArrowRightIcon className='h-5' />
            </Link>}
            {option.mailSended && <p className='text-sm text-center text-gray-500 font-medium'>Vous n'avez pas reçu d'e-mail ? <button type='button' onClick={() => setOption(s => ({ ...s, mailSended: false }))} className='text-teal-700 underline font-bold'>Renvoyer</button></p>}
          </div>
        </section>
      </Fade>
    </div>
  )
}